import { LocaleCode } from '@/locales';

const SITE_LOCALES: Record<string, string> = {
  [LocaleCode.RU]: LocaleCode.RU,
  [LocaleCode.EN]: LocaleCode.EN,
  [LocaleCode.DE]: LocaleCode.DE,
  [LocaleCode.ES]: LocaleCode.ES,
  [LocaleCode.FR]: LocaleCode.FR,
  [LocaleCode.IT]: LocaleCode.IT,
  [LocaleCode.PT]: LocaleCode.PT,
  [LocaleCode.JA]: LocaleCode.JA,
  [LocaleCode.KO]: LocaleCode.KO,
  [LocaleCode.ZH]: LocaleCode.ZH,
  [LocaleCode.ZHT]: LocaleCode.ZH,
  default: LocaleCode.EN,
};

const HELPSHIFT_LOCALES = SITE_LOCALES;

export { SITE_LOCALES, HELPSHIFT_LOCALES };
